/// <amd-module name="Artifacts/Root/types/IFeedIdentity" />
import { ProjectReference } from "Artifacts/Root/web-apis/contracts/Feed";

/**
 * Feed data we need for the feed list
 */
export interface IFeedIdentity {
  /**
   * The Id of the feed.
   */
  id: string;
  /**
   * If the feed has been deleted
   */
  isDeleted: boolean;
  /**
   * The name of the feed.
   */
  name: string;
  /**
   * The Project, if the feed is project-scoped
   */
  project?: ProjectReference;
}
